export default "__VITE_ASSET__BxD3NR_i__"